var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnswerHindi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0V0C24.8366 0 32 7.16344 32 16V16C32 24.8366 24.8366 32 16 32V32C7.16344 32 0 24.8366 0 16V16Z",
    fill: "#DBEFBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.56H22V12.8H20C20.28 13.2 20.42 13.7 20.42 14.28C20.42 15.14 20.06 15.88 19.4 16.44C20.52 17.46 20.96 18.44 20.96 19.6C20.96 21.72 19.34 23 16.94 23C14.1 23 12.16 21.58 10.52 16.92L12.76 15.9C13.9 19.22 14.96 20.7 16.54 20.7C17.52 20.7 18.14 20.16 18.14 19.24C18.14 18.54 17.86 17.94 17.28 17.42C16.7 17.56 16.06 17.66 15.34 17.7L14.94 15.54C16.84 15.4 17.62 15.04 17.62 14.04C17.62 13.56 17.42 13.14 17.04 12.8H10V10.56Z",
    fill: "#1A5C4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerHindi);
export default __webpack_public_path__ + "static/media/AnswerHindi.b41582de787d8ab2dc21af1a81acb27a.svg";
export { ForwardRef as ReactComponent };